export const PRODUCT_EXPLORATION_TOUR_STORAGE_KEY = 'product-exploration-walkthrough-completed';

/** SessionStorage: pathname+search+hash to restore after the Productos walkthrough completes (set when help is used outside landing). */
export const PRODUCT_EXPLORATION_TOUR_RETURN_STORAGE_KEY = 'product-exploration-tour-return-path';

/** DOM anchors for the Productos walkthrough (cross-route). */
export const PRODUCT_EXPLORATION_TOUR_IDS = {
    LANDING_ROOT: 'prod-landing',
    SEARCH: 'search-bar-prod',
    CTA_GRID: 'cta-grid-prod',
    HYBRID_CARD: 'card-dk74',
    HYBRID_TABS: 'tabs-h',
    CP_CARD: 'card-alsystin',
    CP_TABS: 'tabs-cp',
    HELP_LANDING: 'help-prod',
    HELP_LIST: 'help-h',
    HELP_HYBRID_DETAIL: 'help-hd',
    HELP_CP_LIST: 'help-cp',
    HELP_CP_DETAIL: 'help-cpd',
} as const;
